<template>
  <div class="page-wrapper">
    <div class="image-wrapper main-image">

    </div>
    <div class="container text-left">
      <div class="row">
        <div class="col-12">
          <h2>국제특송</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p>
            국제특송은 영국에서 한국으로 소포 또는 기업의 샘플 또는 개인 물품을 보내고자 할 때 이용 가능한 항공운송 서비스이며 픽업 후 약 7일-10일 후 도착지 배송이 가능 합니다. 이 때 화물이 두 박스 이상이고 송하인과 수하인이 같은 경우(즉 보낸 사람이 한국에 귀국을 할 경우는 이삿짐 통관을 해야 하므로 이에 관련된 서류를 준비하셔서 담당 관세사에게 이 메일로 스캔 첨부파일로 보내 주어야 합니다.) – 이 경우 주의할 점은 영국에 6개월 이상 거주를 한 경우 물품 내역에 관계없이 100% 면세이지만 여행자의 경우는 세금이 부과될 수도 있습니다.
          </p>
        </div>
      </div>

      <div class="row text-center">
        <div class="col-4" style="padding-left:5px;padding-right: 5px;" >
          <v-card v-on:click="changeMode(100)">

            <div class="card-header" style="background-image: url('/static/img/house-packing.jpg')">

<!--              <img class="card-img" src="../assets/img/house-packing.jpg">-->
            </div>
            <div class="card-body" :class="{'activated': mode >=100 && mode <= 199}" style="padding-right: 3px;padding-left: 3px;">
              개인 화물 (귀국 이삿짐)
            </div>
          </v-card>
        </div>
        <div class="col-4" style="padding-left:5px;padding-right: 5px;">
          <v-card  v-on:click="changeMode(200)">

            <div class="card-header" style="background-image: url('/static/img/luxuries.jpg')">
            </div>
            <div class="card-body" :class="{'activated': mode >=200 && mode <= 299}" style="padding-right: 3px;padding-left: 3px;">
              구매,배송대행
            </div>
          </v-card>
        </div>
        <div class="col-4" style="padding-left:5px;padding-right: 5px;">
          <v-card  v-on:click="changeMode(300)">

            <div class="card-header" style="background-image: url('/static/img/luxuries.jpg')">
            </div>
            <div class="card-body" :class="{'activated': mode >=300 && mode <= 399}" style="padding-right: 3px;padding-left: 3px;">
              전자 상거래
            </div>
          </v-card>
        </div>
      </div>

    </div>

    <div class="container text-left" v-if="mode == 100">
      <div class="row">
        <div class="col-12">
          <p>개인화물 (귀국이삿짐) 신청시, 아래의 3가지 서류를 다운받으셔서 작성해주세요</p>
          <ul class="clickable">
            <li><span class="border-btn" v-on:click="openTnc('GDPR')">개인정보 수집 활용 동의서 <i class="fas fa-chevron-right"></i></span></li>
            <li><span class="border-btn" v-on:click="openTnc('importReason')">반입 사유서 <i class="fas fa-chevron-right"></i></span></li>
            <li><span class="border-btn" v-on:click="openTnc('moveApplication')">이사 화물 신고서 <i class="fas fa-chevron-right"></i></span></li>
<!--            <li><a href="/static/doc/air_freight_forbidden.pdf" download><span class="border-btn" >금지품목 <i class="fas fa-chevron-right"></i></span></a></li>-->
          </ul>
        </div>

      </div>
    </div>

    <div class="container" style="display:none;">
      <div class="row">
        <div class="col-12 section-header text-left">
          <span><i class="fas fa-box-open"></i></span> 견적내기
        </div>
      </div>

      <div class="row">
        <div class="col-12 text-left">
          박스 사이즈와 무게를 입력해주세요
        </div>
      </div>
      <div class="row">
        <div class="col no-padding-bottom">세로</div>
        <div class="col no-padding-bottom">가로</div>
        <div class="col no-padding-bottom">높이</div>
        <div class="col no-padding-bottom">무게</div>
        <div class="col no-padding-bottom"> </div>

      </div>
      <template v-for="(box, bi) in boxList">
        <div class="row text-right" style="padding-bottom: 10px;">
          <div class="col no-padding">
            <select class="form-control" v-model="box.x" @change="onSizeEntered">
              <option v-for="(n, i) in 100" :value="n">{{n}}cm</option>
            </select>
          </div>
          <div class="col no-padding">
            <select class="form-control" v-model="box.y" @change="onSizeEntered">
              <option v-for="(n, i) in 100" :value="n">{{n}}cm</option>
            </select>
          </div>
          <div class="col no-padding">
            <select class="form-control" v-model="box.z" @change="onSizeEntered">
              <option v-for="(n, i) in 100" :value="n">{{n}}cm</option>
            </select>
          </div>
          <div class="col no-padding">
            <select class="form-control" v-model="box.aw" @change="onSizeEntered">
              <option v-for="(n, i) in 100" :value="n">{{n}}</option>
            </select>
          </div>
          <div class="col no-padding text-center" style="line-height: 38px;">
            <span v-if="bi > 0" v-on:click="removeBox(bi)"><i class="fas fa-trash"></i></span><span v-else> </span>
          </div>
        </div>
      </template>
      <div class="row">
        <div class="col-12 text-left" style="padding-left:0;">
          <span class="border-btn" v-on:click="addBox"><i class="fas fa-plus"></i> 박스 추가</span>
        </div>
      </div>
      <div class="row">
        <table class="table text-left price-container">
          <tr class="">
            <td class="">픽업비: </td>
            <td class="text-left">£{{ volume.pickupPrice.toFixed(2)}}</td>
          </tr>
          <tr class="" v-if="expressBasicPrice != false">
            <td class="">기본요금: </td>
            <td class="text-left">£{{(expressBasicPrice.val2/100).toFixed(2)}} / {{(expressBasicPrice.val/1000).toFixed(3)}}Kg</td>
          </tr>
          <tr class="" v-if="expressAddPrice != false">
            <td class="">추가요금: </td>
            <td class="text-left">£{{(expressAddPrice.val2/100).toFixed(2)}} / {{(expressAddPrice.val/1000).toFixed(3)}}Kg</td>
          </tr>
          <tr class="" v-if="volume.vw > 0">
            <td class="">부피무게: </td>
            <td class="text-left">{{ volume.vw}}Kg</td>
          </tr>
          <tr class="">
            <td class="">가격: </td>
            <td class="text-left">£{{ (volume.price/100).toFixed(2)}}</td>
          </tr>
        </table>
      </div>
      <div class="row">
        <div class="col-12 text-left"><span style="color:#FF5733;">*저렴한 항공 운임으로 낮은 가격 서비스를 제공해드립니다.</span></div>
      </div>
    </div>

    <div class="container" style="display: none;">
      <div class="row">
        <div class="col-12">
          <button class="btn btn-primary" v-on:click="createNewItem">픽업 신청하기</button>
        </div>
      </div>
    </div>


    <div class="container" style="display: none;" v-if="item != false">
      <div class="row">
        <div class="col-12 section-header text-left">
          <span><i class="fas fa-mobile"></i></span> 픽업 신청하기
        </div>
      </div>
    </div>


    <ExpressForm
      v-if="item != false"
      :item="item"
    ></ExpressForm>
  </div>
</template>

<script>
  require('../assets/css/style.css')
  import EventBus from "../api/event-bus";
  import {getNewItem, submitItemRequest} from "../api/item";
  import {getMetaByType} from "../api/meta";
  import ExpressForm from "../form/ExpressForm";

    export default {
        name: "Express",
        components: {
          ExpressForm
        },
        data() {
          return {
            mode:0,
            volume: {
              x:0,
              y:0,
              z:0,
              aw: 0,
              vw: 0,
              cw: 0,
              price: 0,
              pickupPrice:20,
            },
            boxList:[
              {
                x:0,
                y:0,
                z:0,
                aw:0,
                vw:0,
                cw:0,
              }
            ],
            item:false,
            expressBasicPrice:false,
            expressAddPrice: false,
          }
        },
      created() {
        EventBus.$on('onSubmitted', this.onRequestSubmitted);
        this.getExpMetaList();
      },
      methods: {
        getExpMetaList: function() {
          let self = this;
          getMetaByType('exp_base_price')
            .then(function(data) {
              if(data.success == true) {
                self.$data.expressBasicPrice = data.item;
              }
            })
            .catch(function(err) {

            })
          getMetaByType('exp_add_price')
            .then(function(data) {
              if(data.success == true) {
                self.$data.expressAddPrice = data.item;
              }
            })
            .catch(function(err) {

            })
        },
        changeMode: function(newMode) {
          this.$data.mode = 0;
          let self = this;
          setTimeout(function() {
            self.changeModePost(newMode)
          }, 500)
        },
        changeModePost: function(newMode) {
          this.$data.mode = newMode;
          if(this.$data.item != false) {
            if (this.$data.mode >= 100 && this.$data.mode < 199) {
              this.$data.item.requestType = 'personal';
              this.$data.item.tradeType = 'C';
            } else if (this.$data.mode >= 200 && this.$data.mode < 299) {
              this.$data.item.requestType = 'purchase_agent';
              this.$data.item.tradeType = 'C';
            } else if (this.$data.mode >= 300 && this.$data.mode < 399) {
              this.$data.item.requestType = 'ecommerce';
              this.$data.item.tradeType = 'A';
            }
          }

        },
        openTnc: function(tnc) {
          EventBus.$emit("tnc", tnc);
        },
        removeBox: function(index) {
          this.$data.boxList.splice(index, 1);
        },
        addBox: function() {
          let newBox = {
            x:0,
            y:0,
            z:0,
            aw:0,
            vw:0,
            cw:0,
          }
          this.$data.boxList.push(newBox);
        },
          onSizeEntered: function() {
            this.$data.volume.cw = 0;
            this.$data.volume.vw = 0;

            for(let i = 0 ; i < this.$data.boxList.length ; i++) {
              this.$data.boxList[i].vw = parseFloat((this.$data.boxList[i].x * this.$data.boxList[i].y * this.$data.boxList[i].z / 6000).toFixed(2)).toFixed(2);
              this.$data.boxList[i].cw = parseFloat(this.$data.boxList[i].vw) > parseFloat(this.$data.boxList[i].aw) ? parseFloat(this.$data.boxList[i].vw) : parseFloat(this.$data.boxList[i].aw);
              this.$data.volume.cw += this.$data.boxList[i].cw;
              this.$data.volume.vw += this.$data.boxList[i].vw;
            }
            // this.$data.volume.vw = parseFloat((this.$data.volume.x * this.$data.volume.y * this.$data.volume.z / 6000).toFixed(2)).toFixed(2);
            // this.$data.volume.cw = parseFloat(this.$data.volume.vw) > parseFloat(this.$data.volume.aw) ? parseFloat(this.$data.volume.vw) : parseFloat(this.$data.volume.aw);

            this.$data.volume.price = 0;
            if(this.$data.volume.cw >= 20) {
              this.$data.volume.pickupPrice = 0;
            } else {
              this.$data.volume.pickupPrice = 20;
            }

            let cw = parseInt(this.$data.volume.cw*1000);

            this.$data.volume.price = this.$data.expressBasicPrice.val2;

            cw -= this.$data.expressBasicPrice.val;

            while(cw > 0) {
              this.$data.volume.price += this.$data.expressAddPrice.val2;
              cw -= this.$data.expressAddPrice.val;
            }
            console.log(this.$data.volume);
          },

          createNewItem: function() {

            if(this.$data.mode < 100) {
              window.alert("개인화물, 구매배송대행, 전자 상거래중 하나를 선택해주세요");
              return;
            }
            if(this.$data.volume.aw == 0 && this.$data.volume.vw == 0) {
              window.alert("Please enter size")
              return;
            }
            this.$data.item = getNewItem();

            this.$data.item.volumeX = this.$data.volume.x;
            this.$data.item.volumeY = this.$data.volume.y;
            this.$data.item.volumeZ = this.$data.volume.z;
            this.$data.item.boxList = JSON.parse(JSON.stringify(this.$data.boxList));
            this.$data.item.measuredWeight = Number(this.$data.volume.aw);
            this.$data.item.volumeWeight = Number(this.$data.volume.vw * 100);

            this.$data.item.estimatedPrice = 0;
            this.$data.item.estimatedPickupPrice = Number(this.$data.volume.pickupPrice*100);
            this.$data.item.estimatedTotalPrice = this.$data.item.estimatedPrice+this.$data.item.estimatedPickupPrice;

            this.$data.item.requestType = 'purchasing_agent';
            this.$data.item.tradeType = 'C';
            if(this.$data.mode >= 100 && this.$data.mode < 199) {
              this.$data.item.requestType = 'personal';
              this.$data.item.customType = '일';
            } else if(this.$data.mode >= 200 && this.$data.mode < 299) {
              this.$data.item.requestType = 'purchasing_agent';
              this.$data.item.customType = '일';
            } else if(this.$data.mode >= 300 && this.$data.mode < 399) {
              this.$data.item.requestType = 'ecommerce';
              this.$data.item.customType = '목';
              this.$data.item.tradeType = 'A';
            }
            this.$data.item.receiverType = '1';

          },

          onRequestSubmitted: function(item) {
            this.$data.item = false;

            // Display success
            window.alert("감사합니다. 이메일을 확인해주세요");

          }
        }
    }
</script>

<style scoped>
  .main-image {
    background-image: url('../assets/img/airport-cargo.jpg');
  }
  .input-row {
    display: flex;
  }
  .input-row > * {
    height: 40px;
    line-height: 40px;
  }
  .input-row > label {
    width: 100px;
  }
  .input-row > input {
    width: 100px;
  }
  .section-container {
    margin-top:30px;
    border: solid 1px black;
    padding-top:30px;
    padding-bottom: 30px;
    margin-bottom: 30px;
  }
  .row-section {
    margin-top: 30px;
  }
  .no-padding-bottom {
    padding-bottom: 0;
  }
  .no-vertical-padding {
    padding-top:0;
    padding-bottom:0;

  }
  .no-padding {
    padding:0;
  }
  .activated {
    background: #74C77D;
    color:white;
  }
  .section-container {
    margin-top:30px;
    /*border: solid 1px black;*/
    padding-top:30px;
  }
  .row-section {
    margin-top: 30px;
  }
  .card-img-top {
    background: #ccc;
    text-align: center;
    padding-top:20px;
    padding-bottom: 20px;
  }
  .card-header {
    background-position: center;
    background-size: cover;
    height: 250px;
  }
  .card-img {
    width: 80%;
    max-width: 150px;
  }
  @media only screen and (max-width: 420px) {
    .card-body > h2 {
      font-size: small;
    }
    .card-body {
      padding: 0.5rem;
    }
    .card-header {
      height: 150px;
    }
  }
  .no-padding > .form-control {
    padding-left: 0;
    padding-right: 0;
    /*text-align: center;*/
    text-align-last:center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Express.vue